const ANNOTATION_COLORS = {
  measure: "#e53935",
  length: "#1565c0",
  width: "#2e7d32",
};

const ANNOTATION_LABELS = {
  measure: null,
  length: "Длина",
  width: "Ширина",
};

// Draws measurement annotations and pivots onto a scanned image, returns composited JPEG data URL
export async function compositeImage(base64, annotations, dpi = 150) {
  if (!annotations || annotations.length === 0) return base64;

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const lw = Math.max(2, img.naturalWidth / 600);
      const r = Math.max(4, img.naturalWidth / 300);
      const fontSize = Math.max(16, img.naturalWidth / 60);

      annotations.forEach((ann) => {
        if (ann.type === "pivot") return; // pivot removed
        // "region" (foot bounding boxes) and anything else without a measured distance aren't
        // measurement lines — drawing them as a line+label produced a bogus "undefined мм" label.
        // We don't have proper box/valik rendering here (that only exists in the live
        // ImageViewer.jsx canvas), so skip rather than draw something wrong.
        if (ann.type === "region" || ann.distanceMm == null) return;
        const type = ann.type || "measure";
        const color = ANNOTATION_COLORS[type] || "#e53935";

        ctx.save();

        {
          const { x1, y1, x2, y2, distanceMm } = ann;

          // Line
          ctx.strokeStyle = color;
          ctx.lineWidth = lw;
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          ctx.stroke();

          // Endpoint dots
          ctx.fillStyle = color;
          [[x1, y1], [x2, y2]].forEach(([x, y]) => {
            ctx.beginPath();
            ctx.arc(x, y, r, 0, Math.PI * 2);
            ctx.fill();
          });

          // Label
          const mx = (x1 + x2) / 2;
          const my = (y1 + y2) / 2;
          const prefix = ANNOTATION_LABELS[type];
          const label = prefix ? `${prefix}: ${distanceMm} мм` : `${distanceMm} мм`;
          ctx.font = `bold ${fontSize}px sans-serif`;
          const tw = ctx.measureText(label).width;
          const pad = fontSize * 0.4;
          const bh = fontSize * 1.4;
          ctx.fillStyle = "rgba(0,0,0,0.65)";
          ctx.beginPath();
          ctx.roundRect(mx - tw / 2 - pad, my - bh, tw + pad * 2, bh * 1.1, 5);
          ctx.fill();
          ctx.fillStyle = "#ffffff";
          ctx.fillText(label, mx - tw / 2, my - bh * 0.1);
        }

        ctx.restore();
      });

      resolve(canvas.toDataURL("image/jpeg", 0.92));
    };
    img.onerror = () => reject(new Error("Image load failed"));
    img.src = base64;
  });
}
